import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { MEMBERSHIP_IMG } from "@/lib/constants";

export default function Memberships() {
  return (
    <section id="memberships" data-testid="memberships-section" className="bg-[#f7f2e8] overflow-hidden">
      <div className="max-w-[1480px] mx-auto grid lg:grid-cols-2 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="px-5 md:px-10 py-20 md:py-28 flex flex-col justify-center"
        >
          <p className="text-sm text-[#4a4a4a] tracking-wide">Wellness that stays with you.</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] text-[#141414]">
            Memberships Designed
            <br />
            for Your Lifestyle
          </h2>
          <p className="mt-6 text-[#4a4a4a] text-base md:text-lg leading-relaxed max-w-md">
            Choose the membership that fits your goals and enjoy priority access, exclusive
            benefits and ongoing support.
          </p>
          <div className="mt-9">
            <Link
              to="/memberships"
              data-testid="view-membership-plans-button"
              className="btn-gold"
            >
              View Membership Plans <ArrowRight size={15} strokeWidth={2} />
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.2, 0.8, 0.2, 1] }}
          className="relative min-h-[280px] sm:min-h-[360px] lg:min-h-0"
        >
          <img
            src={MEMBERSHIP_IMG}
            alt="Carlton Wellness Center membership cards — Essential, Premium, Platinum"
            data-testid="membership-cards-image"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
}
